import { POST, GET } from './utils';

// creates or loads application
export const GET_PAYMENT_SESSION = ({ userContext, applicationId }) =>
  GET({
    url: `applicationPayment/${applicationId}`,
    token: userContext.accessToken.token
  });
